var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEtudeSection5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 756,
    viewBox: "0 0 649 756",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479 977.5C479 1037.98 429.975 1087 369.5 1087C309.025 1087 260 1037.98 260 977.5L260 109.5C260 49.0248 309.025 0 369.5 0C429.975 0 479 49.0248 479 109.5L479 977.5Z",
    fill: "#005B7F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -194.238,
    y: 496.927,
    width: 219,
    height: 842,
    rx: 109.5,
    transform: "rotate(-89.8725 -194.238 496.927)",
    fill: "#E29578"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -273.06,
    y: 358.927,
    width: 138.928,
    height: 842,
    rx: 69.4639,
    transform: "rotate(-89.8725 -273.06 358.927)",
    fill: "#FFDDD2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -375.996,
    y: 424.927,
    width: 110.488,
    height: 842,
    rx: 55.2441,
    transform: "rotate(-89.8725 -375.996 424.927)",
    fill: "#E8F8FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -449,
    y: 553.927,
    width: 112.107,
    height: 842,
    rx: 56.0537,
    transform: "rotate(-89.8725 -449 553.927)",
    fill: "#679ACB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEtudeSection5);
export default __webpack_public_path__ + "static/media/IllustrationETUDE_Section5.85c5ba1b061625e3bbc1e0541151b6be.svg";
export { ForwardRef as ReactComponent };